import React from 'react';
import { 
  Fab,
  Tooltip,
} from '@mui/material';
import { 
  Feedback as FeedbackIcon,
} from '@mui/icons-material';
import { useFeedbackContext } from '../../contexts/FeedbackContext';

const FeedbackButton: React.FC = () => {
  const { openFeedbackModal } = useFeedbackContext();

  return (
    <Tooltip title="Send Feedback" placement="left">
      <Fab
        color="primary"
        size="medium"
        onClick={() => openFeedbackModal()}
        sx={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          zIndex: 1100,
          background: 'linear-gradient(135deg, #0a7ca0 0%, #0d5f7f 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #0d5f7f 0%, #0a7ca0 100%)',
            transform: 'scale(1.05)',
          },
          transition: 'all 0.3s ease',
        }}
      >
        <FeedbackIcon />
      </Fab>
    </Tooltip>
  );
};

export default FeedbackButton;